<template>
  <div>
    <iframe
      v-if="info.accountId != ''"
      style="border: 1px solid #efefef"
      width="450"
      id="iframe"
      height="800"
      :src="TARD_URL+'/trade/#/index?isGn=true&accountId=' + info.accountId + '&webkey='+webkey+'&name='+info.tacticsName"
      frameborder="no"
      border="0"
      marginwidth="0"
      marginheight="0"
      scrolling="no"
      allowtransparency="yes"
    >
    </iframe>
  </div>
</template>

<script>
let TARD_URL= process.env.VUE_APP_API_TARD_H5_URL
let webkey=  process.env.VUE_APP_APPKEY_URL
export default {
   props: {
    info: Object,
  },
  data() {
    return {
      TARD_URL:TARD_URL,
      webkey:webkey
    }
  },
}
</script>

<style lang="less" scoped>

</style>